class FormattingRuleConfig {
    applyRow: boolean = false;

    constructor(data) {
        this.applyRow = data?.applyRow ?? false;
    }
}